/** Aspect ratios chosen once at narration flow start — used for images, videos, editor preview, and export. */

export const NARRATION_ASPECT_RATIO_OPTIONS = [
  { value: '16:9', label: '16:9 Widescreen', detail: 'YouTube, landscape' },
  { value: '9:16', label: '9:16 Vertical', detail: 'Shorts, Reels, TikTok' },
  { value: '1:1', label: '1:1 Square', detail: 'Instagram feed' },
  { value: '4:3', label: '4:3 Classic', detail: 'TV, presentations' },
  { value: '3:4', label: '3:4 Portrait', detail: 'Tall portrait frames' },
  { value: '2:3', label: '2:3 Portrait', detail: 'Photo-style portrait' },
];

export function narrationAspectRatioLabel(value) {
  const key = String(value || '16:9').trim();
  return NARRATION_ASPECT_RATIO_OPTIONS.find((o) => o.value === key)?.label || key;
}

export function narrationAspectRatioDetail(value) {
  const key = String(value || '16:9').trim();
  return NARRATION_ASPECT_RATIO_OPTIONS.find((o) => o.value === key)?.detail || '';
}

/** Read locked project ratio from narration project `input` or story wrapper. */
export function resolveNarrationProjectAspectRatio(source) {
  if (!source) return '16:9';
  const input = source.input || source;
  return String(input.image_aspect_ratio || '16:9').trim() || '16:9';
}
